// services/leadReportService.js
import http from "./http";

/* =========================
   GET ALL LEADS
========================= */
export const getLeadsReport = async () => {
  try {
    const res = await http.get("/leads_report");
    return res.data;
  } catch (error) {
    console.error("Leads Report Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY DATE
========================= */
export const getLeadsByDate = async (from, to) => {
  try {
    const res = await http.get("/leads_report", {
      params: { from, to },
    });
    return res.data;
  } catch (error) {
    console.error("Leads By Date Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY USER (SALES PERSON)
========================= */
export const getLeadsByUser = async (user_id) => {
  try {
    const res = await http.get("/leads_report", {
      params: { user_id },
    });
    return res.data;
  } catch (error) {
    console.error("Leads By User Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY TM ID (TEAM MEMBER)
========================= */
export const getLeadsByTmId = async (tm_id) => {
  try {
    const res = await http.get("/leads_report", {
      params: { tm_id },
    });
    return res.data;
  } catch (error) {
    console.error("Leads By TM ID Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY LEAD ID
========================= */
export const getLeadById = async (lead_id) => {
  try {
    const res = await http.get("/leads_report", {
      params: { lead_id },
    });
    return res.data;
  } catch (error) {
    console.error("Lead By ID Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   FILTER BY USER NAME
========================= */
export const getLeadsByUserName = async (user_name) => {
  try {
    const res = await http.get("/leads_report", {
      params: { user_name },
    });
    return res.data;
  } catch (error) {
    console.error("Leads By User Name Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};

/* =========================
   GENERIC (BEST 🔥) - Supports all parameters
   Parameters supported:
   - from, to (date range)
   - user_id (sales person ID)
   - tm_id (team member ID)
   - lead_id (specific lead)
   - user_name (name of user)
   - status (lead status)
   - search (search term)
========================= */
export const getLeadsWithParams = async (params = {}) => {
  try {
    const res = await http.get("/leads_report", { params });
    return res.data;
  } catch (error) {
    console.error("Leads Custom Error:", error.response?.data || error);
    return { status: "error", data: [], summary: {} };
  }
};